import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Pill, Users, HeartHandshake, Stethoscope } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Services() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: <Brain className="w-8 h-8 text-brand-teal" data-id="element-182" />,
    title: t('service.psych'),
    description: 'Comprehensive mental health assessments to understand your unique needs.'
  }, {
    icon: <Pill className="w-8 h-8 text-brand-lilac" data-id="element-183" />,
    title: t('service.meds'),
    description: 'Careful monitoring and adjustment of medications to support your treatment.'
  }, {
    icon: <Users className="w-8 h-8 text-brand-deep" data-id="element-184" />,
    title: t('service.therapy'),
    description: 'One-on-one sessions providing a safe space to explore and heal.'
  }, {
    icon: <HeartHandshake className="w-8 h-8 text-pink-500" data-id="element-185" />,
    title: t('service.trauma'),
    description: 'Specialized care to help you process and recover from traumatic experiences.'
  }, {
    icon: <Stethoscope className="w-8 h-8 text-blue-500" data-id="element-186" />,
    title: t('service.diagnosis'),
    description: 'Accurate diagnosis and long-term care plans for sustainable mental health.'
  }];
  return <section id="services" className="py-14 md:py-20 bg-white relative" data-id="element-187">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
        <div className="text-center mb-10 md:mb-16" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-deep mb-4" data-id="element-190">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-191">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-8" data-id="element-192">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-soft hover:shadow-lg transition-all border border-gray-100 group" data-id="element-193">
              <div className="w-16 h-16 rounded-2xl bg-brand-light flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-194">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-deep mb-3" data-id="element-195">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-196">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}